import { render, staticRenderFns } from "./NewPartnerLogin.vue?vue&type=template&id=6a4c6054&scoped=true"
import script from "./NewPartnerLogin.vue?vue&type=script&lang=js"
export * from "./NewPartnerLogin.vue?vue&type=script&lang=js"
import style0 from "./NewPartnerLogin.vue?vue&type=style&index=0&id=6a4c6054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c6054",
  null
  
)

export default component.exports